// import { getAboutPage } from 'utils/api';
import { GetStaticProps } from 'next';
import React from 'react';

import ProcessPage from 'containers/ProcessPage';
import { queryCMS } from 'utils/cms/api';
import { footerQuery, processPageQuery } from 'utils/cms/gql';
import { ISR_TIMEOUT } from 'utils/config';

const Component = props => {
  return <ProcessPage {...props} />;
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const processPageResults = await queryCMS({
    query: processPageQuery({ locale }),
  });

  const processPageData = processPageResults.processPage;

  processPageData.project =
    processPageData.projects[
      Math.floor(Math.random() * processPageData.projects.length)
    ];

  const footerResults = await queryCMS({
    query: footerQuery({ locale }),
  });

  return {
    props: {
      ...processPageData,
      footer: footerResults.footer,
    },
    revalidate: ISR_TIMEOUT,
  };
};

export default Component;
